import type { ProfileSection } from './types';

export const sections: ProfileSection[] = ['personal', 'settings', 'subscriptions'];